// import React, { createContext, useContext, useReducer, useEffect, useCallback } from 'react';


// ! IMPORTANT ! //
// The below code works great as an AuthProvider, allowing for user/staff login.
// Functionality wasn't needed originally, but saving for future updates.
// Maybe a good idea to check git commits to see functional layout.

// // Create an `AuthContext` using the `createContext` function.
// export const AuthContext = createContext();


// const initialState = {
//     isAuthenticated: false,
//     user: null,
// }

// // Manage the authentication state.
// // Reducers let you consolidate a component's state update logic. Context lets you pass information deep down to other components
// function authReducer(state, action) {
//     //switch-case structure to handle various actions to update the state
//     switch (action.type) {
//         case 'LOGIN':
//             return { ...state, isAuthenticated: true, user: action.payload?.user };
//         case 'LOGOUT':
//             return { ...state, isAuthenticated: false, user: null };
//         default:
//             return state;
//     }
// };

// // Create an `AuthProvider` component to wrap your app with the context.
// function AuthProvider({ children }) {
//     const [state, dispatch] = useReducer(authReducer, initialState);

//     // Function to refresh the token
//     const refreshToken = useCallback(async () => {
//         try {
//             const response = await fetch('http://localhost:8000/api/token/refresh', {
//                 method: 'POST',
//                 credentials: 'include', // This is crucial
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (!response.ok) {
//                 console.error('Token refresh failed:', response.status);
//                 dispatch({ type: 'LOGOUT' });
//                 logout();
//                 // navigate('/?login=true');
//             }
//         } catch (error) {
//             console.error('Error refreshing token:', error);
//             dispatch({ type: 'LOGOUT' });
//             logout();
//             // navigate('/?login=true');
//         }
//     }, []);

//     // useEffect(() => {
//     //     if (process.env.NODE_ENV === 'test') {
//     //         // Skip setting up interval in test environment
//     //         return;
//     //     }

//     //     const interval = setInterval(() => {
//     //         console.log('Attempting to refresh token');
//     //         refreshToken();
//     //     }, 10 * 60 * 1000); // Sets time in milliseconds, totals to 600,000ms = 10 mins

//     //     return () => clearInterval(interval);
//     // }, [refreshToken]);


//     const logout = async () => {
//         try {
//             await fetch('http://localhost:8000/api/logout', {
//                 method: 'DELETE',
//                 credentials: 'include', // Include cookies
//             });
//         } catch (error) {
//             console.error('Error during logout:', error);
//         }
//         dispatch({ type: 'LOGOUT' });
//     };


//     useEffect(() => {
//         const checkAuth = async () => {
//             try {
//                 // console.log('Attempting to authenticate...');
//                 const response = await fetch('http://localhost:8000/api/authenticate', {
//                     method: 'GET',
//                     credentials: 'include',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                 });
//                 if (response.ok) {
//                     const data = await response.json();
//                     if (data.is_authenticated) {
//                         dispatch({ type: 'LOGIN', payload: { user: data.user } });
//                     } else {
//                         dispatch({ type: 'LOGOUT' });
//                     }
//                 } else {
//                     console.error('Authentication failed:', response.status, response.statusText);

//                 }
//             } catch (error) {
//                 console.error('Error checking authentication status:', error.message);
//             }
//         };
//         checkAuth();
//     }, [dispatch]);
//     // The `AuthProvider` will provide the context value to its children.
//     return <AuthContext.Provider value={{ state, dispatch, refreshToken, logout }}>{children}</AuthContext.Provider>;
// };

// function useAuth() {
//     const context = useContext(AuthContext);
//     if (!context) {
//         throw new Error('useAuth must be used within an AuthProvider');
//     }
//     return context;
// };

// export { AuthProvider, useAuth };

// --------------------------------------------------------

// DUMMY AUTHPROVIDER TO PREVENT ERRORS

import React, { createContext, useContext, useReducer } from 'react';

export const AuthContext = createContext();

const initialState = {
    isAuthenticated: false,
    user: null,
};

function authReducer(state, action) {
    switch (action.type) {
        case 'LOGIN':
            return { ...state, isAuthenticated: true, user: action.payload?.user };
        case 'LOGOUT':
            return { ...state, isAuthenticated: false, user: null };
        default:
            return state;
    }
};

function AuthProvider({ children }) {
    const [state, dispatch] = useReducer(authReducer, initialState);

    // Keep the logout function for manual logout operations if needed
    const logout = () => {
        dispatch({ type: 'LOGOUT' });
    };

    // Provide dummy implementations to avoid runtime errors
    const refreshToken = () => {};
    const checkAuth = () => {};

    // Still return context provider with dummy functions to keep structure
    return (
        <AuthContext.Provider value={{ state, dispatch, refreshToken, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export { AuthProvider, useAuth };
